export const LANG_RU_NAME = "ru";

export const LANG_RU_TRANS = {
  /* Select Language */
  lang_az: "Azerbaycanca",
  lang_en: "İngilizce",
  lang_tr: "Türkçe",
  lang_ru: "Rusça",
  Turkey: "Türkiye",

  /********** BELGE TÜRLERİ **********/
  /* SATINALMA MODULU */
  PURCHASE_DISPATCH: "Satınalma İrsaliyesi",
  PURCHASE_RETURN_DISPATCH: "Satınalma İade İrsaliyesi",
  PURCHASE_CONSIGNMENT_DISPATCH: "Konsinye Giriş İrsaliyesi",
  PURCHASE_CONSIGNMENT_RETURN_DISPATCH: "Konsinye Giriş İade İrsaliyesi",
  PURCHASE_RETURN_INVOICE: "Satınalma İade Faturası",
  PURCHASE_INVOICE: "Satınalma Faturası",
  PURCHASE_RECEIVE_SERVICE_INVOICE: "Alınan Hizmet Faturası",
  PURCHASE_RECEIVE_PROFORMA_INVOICE: "Alınan Proforma Faturası",
  PURCHASE_PRICE_DIFF_INVOICE: "Satınalma Fiyat Farkı Faturası",
  PURCHASE_PRODUCER_INVOICE: "Muhtahsil Makbuzu",
  PURCHASE_SERVICE_CARD: "Alınan Hizmet Kartları",
  /*SATIŞ MODULU */
  SALES_INVOICE: "Satış Faturaları",
  SALES_SERVICE_CARD: "Verilen Hizmet Kartları",
  SALES_RETAIL_INVOICE: "Perakende Satış Faturası",
  SALES_RETAIL_RETURN_INVOICE: "Perakende Satış İade Faturası",
  SALES_WHOLESALE_INVOICE: "Toptan Satış Faturası",
  SALES_WHOLESALE_RETURN_INVOICE: "Toptan Satış İade Faturası",
  SALES_GIVEN_SERVICE_INVOICE: "Verilen Hizmet Faturası",
  SALES_GIVEN_PROFORMA_INVOICE: "Verilen Proforma Faturası",
  SALES_PRICE_DIFF_INVOICE: "Satış Fiyat Farkı Faturası",
  SALES_DISPATCH: "Satış İrsaliyeleri",
  SALES_RETAIL_DISPATCH: "Perakende Satış İrsaliyesi",
  SALES_RETAIL_RETURN_DISPATCH: "Perakende Satış İade İrsaliyesi",
  SALES_WHOLESALE_DISPATCH: "Toptan Satış İrsaliyesi",
  SALES_WHOLESALE_RETURN_DISPATCH: "Toptan Satış İade İrsaliyesi",
  SALES_CONSIGNMENT_DISPATCH: "Konsinye Çıkış İrsaliyesi",
  SALES_CONSIGNMENT_RETURN_DISPATCH: "Konsinye Çıkış İade İrsaliyesi",
  /* CARİ HESAP FİŞLERİ */
  CURR_ACCOUNT_REMITTANCE_RECEIPT: "Virman Fişi",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT: "Kur Farkı Fişi",
  CURR_ACCOUNT_CASH_COLLECTION: "Nakit Tahsilat",
  CURR_ACCOUNT_CASH_PAYMENT: "Nakit Ödeme",
  CURR_ACCOUNT_DEBIT_NOTE: "Borç Dekontu",
  CURR_ACCOUNT_CREDIT_NOTE: "Alacak Dekontu",
  /* MALZEME YÖNETİM FİŞLERİ */
  MATERIAL_SCRAP_RECEIPT: "Fire Fişi",
  MATERIAL_USAGE_RECEIPT: "Sarf Fişi",
  SHORTAGE_STOKC_RECEIPT: "Sayım Eksiği Fişi",
  MATERIAL_EXCESS_STOCK_RECEIPT: "Sayım Fazlası Fişi",
  MATERIAL_WAREHOUSE_OUTPUT_RECEIPT: "Depo Çıkış Fişi",
  MATERIAL_WAREHOUSE_INPUT_RECEIPT: "Depo Giriş Fişi",
  MATERIAL_WAREHOUSE_TRANSFER_RECEIPT: "Depolar Arası Transfer Fişi",

  /* ENUMS */
  COMMERCIAL_GOODS: "Ticari Mal",
  PRODUCT: "Mamül",
  SEMI_PRODUCT: "Yarı mamül",
  RAW_MATERIAL: "Ham madde",
  MATERIAL: "Malzeme",
  SERVICE: "Hizmet",
  FUEL: "Akaryakıt",
  CURRENT_ACCOUNT_SELLER: "Müşteri / Satıcı",
  CURRENT_ACCOUNT: "Müşteri",
  SELLER: "Satıcı",
  ACTIVE: "Aktif",
  PASSIVE: "Pasif",
  DISCOUNT: "İndirim",
  EXPENSE: "Masraf",
  PURCHASEMANAGER: "Satınalma Sorumlusu",
  SALESMANAGER: "Satış Sorumlusu",
  MATERIAL_CARD: "Malzeme Kartları",
  CURRENT_ACCOUNT_CARD: "Cari Hesap Kartları",
  NO: "Hayır",
  LOT: "Lot",
  SERIAL_NUM: "Seri No",
  NONE: "Yok",
  WEIGHTED: "Tartılı",
  COUNTLINE: "Adetli",
  PLU: "Plu",
  INVOICED: "Faturalanmış",
  NOTINVOICED: "Faturalanmamış",
  FIXED: "Sabit",
  INCREMENTAL: "Artan",
  GROUPEDINCREMENTAL: "Gruplanmış Artımlı",
  BRANCHNO: "Şube No",
  WAREHOUSENO: "Depo No",
  USERCODE: "Kullanıcı Kodu",
  SERVICEPURCHASE: "Alınan Hizmet",
  SERVICESALES: "Verilen Hizmet",
  YEAR: "Yıl",
  MONTH: "Ay",
  WEEK: "Hafta",
  DAY: "Gün",
  HOURS: "Saat",
  COMPANY: "Şirket",
  SUBCOMPANY: "Alt Şirket",
  ROLE_ADMIN: "Admin",
  ROLE_SUPERVISOR: "Supervisor",
  ROLE_USER: "Kullanıcı",
  ROLE_GUEST: "Misafir",
  TRANSFERRER_BALANCE: "Devreden bakiye",
  /* Toolbar / Grid /Genel */
  new: "Yeni",
  copy: "Kopyala",
  edit: "Güncelle",
  view: "İncele",
  delete: "Sil",
  do_yes: "Evet",
  do_no: "Hayır",
  exit: "Çıkış",
  remove: "Çıkar",
  save: "Kaydet",
  save_and_new: "Kaydet ve Yeni",
  save_and_close: "Kaydet ve Kapat",
  close: "Kapat",
  cancel: "Vazgeç",
  ok: "Tamam",
  apply: "Uygula",
  add: "Ekle",
  refresh: "Yenile",
  all_of: "Hepsini",
  list: "Liste",
  lists: "Listele",
  export: "Dışa Aktar",
  excel_export: "Excel olarak",
  pdf_export: "PDF olarak",
  other: "Diger",
  column_add_or_remove: "Kolon Ekle / Kaldır",
  field_add_or_remove: "Alan Ekle / Kaldır",
  loading: "Yükleniyor",
  grid_design: "Grid Tasarımı",
  design: "Tasarım",
  new_design: "Yeni Tasarım",
  save_design: "Tasarımı Kaydet",
  save_design_or_load: "Tasarımı Kaydet / Yükle",
  saved_designs: "Kayıtlı Tasarımlar",
  save_new_design: "Yeni tasarım olarak kaydet",
  edit_design: "Tasarımı Düzenle",
  default_design: "Varsayılan Tasarım",
  save_as_default: "Öndeğer olarak kaydet",
  add_new_line: "Yeni Satır Ekle",
  add_line: "Satır Ekle",
  add_new_line_or_delete: "Yeni Satır Ekle / Sil",
  select: "Seç",
  new_record: "Yeni Kayıt",
  edit_record: "Güncelleme",
  error: "Hata!",
  excel: "Excel",
  pdf: "Pdf",
  not_found: "Bulunamadı",
  do_filter: "Lütfen filtreleme yapınız",
  billing_to: "Faturalaştır",
  all: "Tümü",
  saving: "Kaydediliyor",
  deleting: "Siliniyor",
  EQ: "Eşit",
  NOT_EQ: "Eşit değil",
  GT: "Büyük",
  GE: "Büyük eşit",
  LT: "Küçük",
  LE: "Küçük eşit",
  LIKE: "Benzer",
  NOT_LIKE: "Benzer değil",
  START_WITH: "İle başlar",
  END_WITH: "İle biter",
  IN: "İçeren",
  NOT_IN: "İçermez",
  BETWEEN: "Arasında",
  expression_eq: "Eşittir",
  expression_between: "Arasında",
  expression_in: "İçinde",
  couldnot_connect_server: "Sunucuya bağlanılamadı.",
  detail_filter: "Detaylı Filtre",
  details: "Detaylar",
  new_filter: "Yeni Filtre",
  create_new_design: "Yeni tasarım oluştur",
  filter_edit: "Filtre Güncelle",
  filter: "Filtre",
  filter_name: "Filtre Adı",
  field_list: "Alan Listesi",
  select_lang: "Dil seçiniz",
  select_all: "Tümünü seç",
  un_select_all: "Tümünü kaldır",
  view_source: "Kaynağı görüntüle",
  processing_is_working: "İşleminiz yapılıyor",
  value: "Değer",
  important_area: "Bu alanın doldurulması gereklidir",
  bad_credentials: "Hatalı kullanıcı adı ya da şifre",
  couldnot_login: "Giriş yapılamadı",
  untitled_error: "Bilinmeyen bir hata meydana geldi.",
  default_language: "Varsayılan Dil",
  language: "Dil",
  username: "Kullanıcı adı",
  forgot_pass: "Şifremi unuttum",
  login_error: "Bir sorun oluştu lütfen tekrar deneyiniz",
  signin: "OTURUM AÇ",
  login: "Giriş",
  logout: "Çıkış yap",
  wrong_mail_address_type: "Mail adresi yanlıştır",
  test_mail_send_success_message: "Test Maili Başarılı",
  test_mail_send_error_message: "Test Maili Başarısız",
  download_message_content: "Mesaj İçeriğini İndir",
  send_file: "Dosya Gönder",
  delete_message: "Mesajı Sil",
  invoice_status: "Fatura Durumu",
  current_account_special_code: "Cari Özel Kod",
  profile: "Profil",
  success: "Başarılı",
  success_message: "İşleminiz başarıyla gerçekleştirilmiştir",
  password_set_error: "Şifre oluşturulken Hata oluştu",
  password_reset_error: "Şifre Sıfırlanırken Hata oluştu",
  password: "Şifre",
  current_password: "Mecvut Şifre",
  new_password: "Yeni Şifre",
  new_password_confirmation: "Yeni Şifre Tekrarı",
  set_password: "Şiref oluştur",
  reset_password: "Şifreyi sıfırla",
  reset_my_password: "Şifremi sıfırla",
  password_not_same: "Şifreler eşleşmiyor",
  send_reset_link_success_message:
    "Belirtmiş olduğunuz e-posta adresine şifre sıfırlama yönergelerini içeren mail gönderilmiştir. Lütfen mail kutunuzu kontrol ediniz.",
  reset_password_success_message:
    "Şifreniz başarılı bir şekilde sıfırlanmıştır",
  set_new_password_success_message:
    "Şifreniz başarılı bir şekilde kaydedilmiştir",
  password_change_success_message:
    "Şifreniz başarılı bir şekilde değiştirilmiştir",
  new_user: "Yeni Kullanıcı İsteği",
  user_create_send_mail:
    " e-posta adresine şifre oluşturma linki gönderilmiştir",
  help_center: "Yardım Merkezi",
  not_access_token_error: "Erişim İzniniz Bulunamadı!",
  lines: "Satırlar",
  line: "Satır",
  status: "Durumu",
  type: "Türü",
  send_report: "Rapor Gönder",
  list_report: "Liste Raporu",
  matrix_report: "Matris Raporu",
  excel_report: "Excel Raporu",
  monitor_report: "Ekran Raporu",
  report_name: "Rapor Adı",
  report_fields: "Rapor Alanları",

  debit: "Borç",
  credit: "Alacak",
  local_debit: "Yerel Borç",
  local_credit: "Yerel Alacak",
  unselected: "Seçilmemiş",
  add_shipping_address: "Sevkiyat Adresi Ekle",
  shipping_address: "Sevkiyat Adresleri",
  add_invoice_address: "Fatura Adresi Ekle",
  document_num: "Fiş No",
  external_document_num: "Belge No",
  current_account_code: "Cari Hesap Kodu",
  current_account_name: "Cari Hesap Ünvanı",
  current_account_description: "Cari Hesap Ünvanı",
  current_account_specode: "Cari Özel Kod",
  current_account_specode2: "Cari Özel Kod2",
  current_account_specode3: "Cari Özel Kod3",
  current_account_specode4: "Cari Özel Kod4",
  current_account_status: "Durumu",
  current_account_user: "Kayıt Yapan Kullanıcı",
  current_account_receipt: "Cari Hesap Fişleri",
  current_account_extract: "Cari Hesap Ekstresi",
  processes: "İşlemler",
  process: "İşlem",
  messages: "Mesajlar",
  message: "Mesaj",
  exchange_rate: "Kur",
  exchange: "Döviz",
  warning: "Uyarı",
  surname: "Soyadı",
  name: "Adı",
  fullname: "Tam Adı",
  title: "Ünvanı",
  father_name: "Baba Adı",
  mother_name: "Anne Adı",
  birth_date: "Doğum Tarihi",
  birth_place: "Doğum Yeri",
  register_num: "Sicil No",
  identity_num: "Kimlik Numarası",
  gender: "Cinsiyet",
  nationality: "Uyruğu",
  religion: "Dini",
  marital_status: "Medeni Durumu",
  single: "Bekar",
  married: "Evli",
  separated: "Ayrılmış",
  divorced: "Boşanmış",
  widowed: "Dul",
  blood_group: "Kan Grubu",
  o_positive: "O Rh+",
  o_negative: "O Rh-",
  a_positive: "A Rh+",
  a_negative: "A Rh-",
  ab_positive: "AB Rh+",
  ab_negative: "AB Rh-",
  b_positive: "B Rh+",
  b_negative: "B Rh-",
  registered_population: "Nüfusa Kayıtlı Olduğu",
  person_id: "Kimliğin",
  volume_num: "Cilt No",
  family_num: "Aile Sıra No",
  sequence_num: "Sıra No",
  serial_num: "Seri No",
  serial_lot_description: "Seri/Lot Açıklama",
  serial_lot_num: "Seri/Lot No",
  serial_lot_transactions: "Seri/Lot Giriş Hareketleri",
  serial_lot_transaction: "Seri/Lot Giriş Hareketi",
  transaction: "Hareket",
  transactions: "Hareketler",
  registration_num: "Kayıt No",
  given_place: "Verildiği Yer",
  given_date: "Verildiği Tarih",

  male: "Erkek",
  female: "Kadın",
  bank: "Banka",
  bank_account_num: "Banka Hesap Numarası",
  account_num: "Hesap Numarası",
  bank_branch: "Banka Şubesi",
  iban_num: "İban Numarası",
  iban: "İban",
  row_num: "Sıra No",
  number: "No",
  description: "Açıklama",
  branch: "Şube",
  branch_name: "Şube Adı",
  brand: "Marka",
  brand_code: "Marka Kodu",
  materialSpecode: "Malzeme Özel Kodu",
  specode_description: "Özel Kod Açıklaması",
  specode_code: "Özel Kod Kodu",
  specode_type: "Özel Kod Türü",
  material_special_code: "Malzeme Özel Kodu",
  current_ccount_specode: "Cari Hesap Özel Kodu",
  bank_accounts: "Banka Hesapları",
  bank_account: "Banka Hesabı",
  specode: "Özel Kod",
  special_code: "Özel Kod",
  special_code2: "Özel Kod 2",
  special_code3: "Özel Kod 3",
  special_code4: "Özel Kod 4",
  special_code5: "Özel Kod 5",
  code: "Kodu",
  company: "Şirket",
  companies: "Şirketler",
  input_quantity: "Giriş Miktarı",
  quantity: "Miktar",
  remaining_quantity: "Kalan Miktar",
  price: "Fiyat",
  unit_price: "Birim Fiyatı",
  local_price: "Yerel Fiyatı",
  cost: "Masraf",
  tax_num: "Vergi No",
  tax_office: "Vergi Dairesi",
  address: "Adres",
  home_phone: "Ev Telefonu",
  mobile_phone: "Cep Telefonu",
  phone: "Telefon",
  phone2: "Telefon 2",
  fax_num: "Faks Numarası",
  email_address: "Mail Adresi",
  e_mail: "E-Posta Adresi",
  email: "Mail Adresi",
  send_test_mail: "Test Maili Gönder",
  subject: "Konu",
  receiver: "Alıcı",
  to_whom: "Kime",
  text: "Metin",
  company_email: "Şirket Maili",
  company_phone: "Şirket Telefonu",
  internal_phone: "Dahili No",
  web_address: "Internet Adresi",
  trade_register_num: "Ticaret Sicil No",
  mersis_num: "Mersis No",
  web_service_address: "Web Servis Adresi",
  database_name: "Veritabanı Adı",
  server_name: "Sunucu Adı",
  port: "Port",
  use_ssl: "SSL Kullan",
  company_num: "Firma No",
  period_num: "Dönem No",
  branch_num: "Şube No",
  warehouse_num: "Depo No",
  picture: "Resim",
  pictures: "Resimler",
  country: "Ülke",
  region: "Bölge",
  territory: "Bölge",
  sales_territory: "Satış Bölgesi",
  sales_territories: "Satış Bölgeleri",
  state: "Eyalet",
  branch_region: "Bölge",
  city: "İl",
  town: "İlçe",
  village: "Köy / Kasaba",
  county: "İlçe",
  sector: "Sektör",
  day: "Gün",
  week: "Hafta",
  date: "Tarih",
  time: "Saat",
  month: "Ay",
  year: "Yıl",
  expiration_date: "Son Kullanma Tarihi",
  exp_date: "Son Kul. Tarihi",
  created_date: "Oluşturulma Tarihi",
  begin_date: "Başlangıç Tarihi",
  end_date: "Bitiş Tarihi",
  active_period: "Aktif Dönem",
  working_period: "Çalışma Dönemi",
  active_working_period: "Aktif Çalışma Dönemi",
  tooltip: "Bu kaydı seçip hızli işlem gerçekleştirebilirsiniz.",

  entry_info: "Kayıt Bilgisi",
  filter_count: "Sayı",
  short_name: "Kısa adı",
  short_description: "Kısa Açıklama",
  unpurchasable: "Satınalma Yapılamaz",
  tracking_method: "Seri/Lot",
  category: "Kategori",
  shelf_life: "Raf ömrü",
  plu_num: "Plu No",
  producer_material_code: "Üretici Malzeme Kodu",
  origin: "Menşei",
  barcodes: "Barkodlar",
  material_responsibility: "Ürün Sorumluları",
  barcode: "Barkod",
  unit_type: "Birimi",
  payment_type: "Ödeme Tipi",
  product_manager: "Ürün Sorumlusu",
  unit_sets: "Birim Setleri Çarpanları",
  unit_set_code: "Birim Seti Kodu",
  unit_code: "Birim Kodu",
  multiplier: "Çarpan",
  sales_information: "Satış Bilgileri",
  purchase_information: "Satın Alma Bilgileri",
  unsaleable: "Satış Yapılamaz",
  unsaleable_order: "Satış Siparişi Açılamaz",
  untransferable: "Transfer Edilemez",
  sales_unit: "Satış Birimi",
  purchase_unit: "Satınalma Birimi",
  unpurchaseable: "Satınalma Yapılamaz",
  unpurchaseable_order: "Satınalma Siparişi Verilemez",
  unit_name: "Birim Adı",
  shortName: "Kısa Adı",
  related_companies: "İlişkili Şirketler",
  overview: "Genel Bakış",
  erp_menu: "ERP Menü",
  admin_menu: "Yönetim Menü",
  favorites: "Sık Kullanılanlar",
  main_records: "Ana Kayıtlar",
  sales_personal: "Satıcılar",
  sales_person_code: "Satış Elemanı Kodu",
  employees: "Çalışanlar",
  employee: "Çalışan",
  material_management: "Malzeme Yönetimi",
  current_account_item_code: "Tedarikçi Malzeme Kodu",
  service_cards: "Hizmet Kartları",
  service_card: "Hizmet Kartı",
  suppliers: "Tedarikçiler",
  purchase_management: "Satınalma",
  dispatch_date: "İrsaliye Tarihi",
  invoice_date: "Fatura Tarihi",
  dispatch_first_date: "İrsaliye İlk Tarih",
  invoice_first_date: "Fatura İlk Tarih",
  dispatch_last_date: "İrsaliye Son Tarih",
  invoice_last_date: "Fatura Son Tarih",
  dispatch_num: "İrsaliye No",
  invoice_num: "Fatura No",
  receipt_num: "Fiş No",
  dispatches: "İrsaliyeler",
  purchase_dispatch: "Satınalma İrsaliyesi",
  purchase_dispatches: "Satınalma İrsaliyeleri",
  purchase_invoice: "Satınalma Faturası",
  purchase_invoices: "Satınalma Faturaları",
  sales_dispatch: "Satış İrsaliyesi",
  sales_dispatches: "Satış İrsaliyeleri",
  sales_invoice: "Satış Faturası",
  sales_invoices: "Satış Faturaları",
  invoices: "Faturalar",
  buying_management: "Satınalma Yönetimi",
  sales_management: "Satış Yönetimi",
  sales: "Satış",
  finance_management: "Finans Yönetimi",
  it_management: "BT Yönetimi",
  app_management: "Uygulama Parametreleri",
  dispatchInfo: "İrsaliye Bilgileri",
  finance: "Finans",
  definitions: "Tanımlar",
  materials: "Malzemeler",
  company_based_materials: "Şirket Bazında Malzemeler",
  material_definitions: "Malzeme Tanımları",
  cards: "Kartlar",
  sales_person: "Satış Elemanları",
  units: "Birimler",
  unit: "Birim",
  master_unit: "Ana Birim",
  master_units: "Ana Birimler",
  unit_set: "Birim Setleri",
  unit_set_units: "Birim Set Birimleri",
  movements: "Hareketler",
  reports: "Raporlar",
  report: "Rapor",
  extracts: "Ekstreler",
  extract: "Ekstre",
  brands: "Markalar",
  user_roles: "Kullanıcı Rolleri",
  users: "Kullanıcılar",
  user: "Kullanıcı",
  registrant_user: "Kayıt Yapan Kullanıcı",
  role_permission: "Rol Yetkisi",
  role_permissions: "Rol Yetkileri",
  all_user: "Tüm Kullanıcılar",
  active_user: "Aktif Kullanıcı",
  valid_for_all_users: "Tüm kullanıcılar için geçerli",
  user_role: "Kullanıcı Rolü",
  role_name: "Rol Adı",
  password_expired: "Parola Bitiş Tarihi",
  rayons: "Reyonlar",
  rayon: "Reyon",
  rayon_code: "Reyon Kodu",
  special_codes: "Özel Kodlar",
  current_accounts: "Cari Hesaplar",
  current_account: "Cari Hesap",
  balance: "Bakiye",
  isprivate_company: "Şahıs Şirketi",
  general: "Genel",
  general_information: "Genel Bilgiler",
  identity_information: "Kimlik Bilgileri",
  in_detail_information: "Detay Bilgileri",
  in_vat_information: "Vergi Oranları",
  contact_information: "İletişim Bilgileri",
  address_information: "Adres Bilgileri",
  other_information: "Diğer Bilgiler",
  commercial_information: "Ticari Bilgiler",
  params: "Parametreler",
  total: "Toplam",
  net_total: "Net Toplam",
  discount: "İndirim",
  vat: "KDV",
  vat_amount: "KDV Tutarı",
  vat_group: "KDV Grubu",
  vat_groups: "KDV Grupları",
  vat_group_name: "KDV Grup Adı",
  vat_rates: "KDV Oranları",
  vat_rate: "KDV %",
  vat_included: "KDV (D/H)",
  purch_vat_rate: "Alış KDV Oranı",
  sales_vat_rate: "Satış KDV Oranı",
  persale_vat_rate: "Perakende Satış KDV Oranı",
  persale_department: "Perakende Satış Departmanı",
  sales_department: "Topdan Satış Departmanı",
  working_periods: "Çalışma Dönemleri",
  workingPeriod: "Çalışma Dönemi",
  added: "Ekleyen",
  last_changed: "Son Değiştiren",
  sectors: "Sektörler",
  branches: "Şubeler",
  regions: "Bölgeler",
  warehouses: "Depolar",
  payment_plans: "Ödeme Planları",
  payment_plan: "Ödeme Planı",
  warehouse: "Depo",
  email_settings: "E-Mail Ayarları",
  company_settings: "Şirket Ayarları",
  number_series: "Numara Serileri",
  vouchers: "Fişler",
  required_fields: "Zorunlu Alanlar",
  required_fields_must_be_entered: "Zorunlu Alanlar Girilmelidir",

  bank_codes: "Banka Kodları",
  tax_houses: "Vergi Daireleri",
  customer: "Müşteri",
  material: "Malzeme",
  material_management_receipt: "Malzeme Yönetim Fişi",
  material_management_receipts: "Malzeme Yönetim Fişleri",
  material_not_found: "Ürün bulunamadı",
  debit_and_credit_must_equals: "Borç ve alacak toplamları eşit olmalıdır",
  debit_and_credit_not_equals: "Borç ve alacak toplamları eşit değil",
  company_based_material: "Şirket Bazında Malzeme",
  MAIN_CURRENT_ACCOUNT: "Ana Cari",

  NOACTION: "İşlem Yapılmayacak",
  CASH: "Nakit",
  CREDITCARD: "Kredit Kartı",
  PURCHASE_AMOUNT: "Döviz Alış",
  SALES_AMOUNT: "Döviz Satış",
  EFFECTIVE_PURCHASE_AMOUNT: "Efektif Alış",
  EFFECTIVE_SALES_AMOUNT: "Efektif Satış",
  EXCHANGE_BUYING: "Döviz Alış",
  EXCHANGE_SALES: "Döviz Satış",
  EFFECTIVE_BUYING: "Efektif Alış",
  EFFECTIVE_SALES: "Efektif Satış",
  currency_type: "Döviz Tipi",
  line_type: "Türü",
  main_current_account: "Ana Cari",
  current_account_type: "Cari Türü",
  rate_calc_type: "Kur Hesaplama Tipi",
  rate: "Oran",

  number_schema: "Numaralama Şablonları",
  document_type: "Belge Türü",
  document_date: "Belge Tarihi",
  document_time: "Belge Saati",
  last_num: "Son Numara",
  amount: "Tutar",
  total_amount: "Tutar",
  local_total_amount: "Yerel Tutar",
  net_total_amount: "Toplam Tutar",
  gross_total_amount: "Tutar",
  number_schema_detail: "Numaralandırma Detayı",
  length: "Uzunluk Sayısı",
  property: "Özellik",
  start_num: "Başlangıç Numarası",
  end_num: "Bitiş Numarası",
  branch_undefined: "Şube bulunamadı.",
  not_match_length: "Girilen değer uzunluk alanından büyük olamaz",
  cant_blank_length: "Uzunluk boş bırakılamaz",
  select_first_company: "Şirket seçiniz.",
  select_and_continue: "Seç ve Yeni Satır",
  number_scheme_detail: "Numaralama Detayı",
  numberscheme: "Numaralama Şablonu",
  scales: "Terazi İlişkilendirme",

  material_status: "Malzeme Durumu",
  material_barcode: "Malzeme Barkodu",
  material_type: "Malzeme Tipi",
  material_code: "Malzeme Kodu",
  material_description: "Malzeme Açıklaması",
  material_specode: "Malzeme Özel Kod",
  material_specode2: "Malzeme Özel Kod 2",
  material_specode3: "Malzeme Özel Kod 3",
  material_specode4: "Malzeme Özel Kod 4",
  material_specode5: "Malzeme Özel Kod 5",
  material_user: "Kayıt Yapan Kullanıcı",
  specode_user: "Kayıt Yapan Kullanıcı",
  record_date: "Kayıt Tarihi",
  first_record_date: "İlk Kayıt Tarihi",
  first_date: "İlk Tarih",
  last_record_date: "Son Kayıt Tarihi",
  last_date: "Son Tarih",
  last_changed_user: "Son Değiştiren Kullanıcı",
  first_date_changed: "İlk Değiştirme Tarihi",
  last_date_changed: "Son Değiştirme Tarihi",

  company_number: "Firma No",
  company_description: "Firma Ünvanı",
  working_period_number: "Dönem No",
  working_period_description: "Dönem Adı",
  branch_number: "Şube Kodu",
  branch_description: "Şube Adı",
  warehouse_description: "Depo Adı",
  warehouse_number: "Depo Kodu",
  current_account_tax_office: "CH Vergi Dairesi",
  current_account_tax_num: "CH Vergi No",
  current_account_identity_num: "CH Kimlik No",
  current_account_country_description: "CH Ülke",
  current_account_region_description: "CH Bölge",
  current_account_city_description: "CH İl",
  current_account_county_description: "CH İlçe",
  current_account_address: "CH Adres",
  current_account_phone: "CH Telefon",
};
